import { useEffect, useRef } from "react";
import { readPathDetail } from "./engine/readPathDetail.js";
import { telemetryEngine } from "./engine/telemetryEngine.js";
function useMonitorUrl(enabled) {
  const rPathDetail = useRef(void 0);
  useEffect(() => {
    if (enabled && window.navigation) {
      let onNavigate2 = function() {
        const pathDetail = readPathDetail();
        if (rPathDetail.current?.urlPath !== pathDetail.urlPath || rPathDetail.current.urlHash !== pathDetail.urlHash) {
          rPathDetail.current = pathDetail;
          telemetryEngine.waitAfterUrlChange();
        }
      };
      var onNavigate = onNavigate2;
      if (rPathDetail.current === void 0) {
        onNavigate2();
      }
      window.navigation.addEventListener("navigate", onNavigate2);
      return () => {
        window.navigation.removeEventListener("navigate", onNavigate2);
      };
    }
  }, [enabled]);
}
export {
  useMonitorUrl
};
//# sourceMappingURL=useMonitorUrl.js.map
